export const DEMO_BOOKING_URL =
  'https://sniffrai.zohobookings.in/#/445481000000031050';

export const DEMO_BOOKING_EMBED_URL =
  'https://sniffrai.zohobookings.in/portal-embed#/445481000000031050';